import React, { useState, useEffect, useCallback } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import MemoryAgent from "./pages/MemoryAgent";
import TechFocus from "./pages/TechFocus";
import Contact from "./pages/Contact";

export default function PortfolioContainer() {
  const [activeSection, setActiveSection] = useState("home");

  const handleScroll = useCallback(() => {
    const sections = ["home", "venture", "tech", "about", "contact"];
    const scrollPos = window.scrollY + 120;

    for (let i = sections.length - 1; i >= 0; i--) {
      const el = document.getElementById(sections[i]);
      if (el && el.offsetTop <= scrollPos) {
        setActiveSection(sections[i]);
        break;
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="site-wrapper">
      <Header activeSection={activeSection} scrollTo={scrollTo} />
      <Home scrollTo={scrollTo} />
      <MemoryAgent />
      <TechFocus />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
